import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { StorageService } from '../../../core/storage/storageService';
import { User } from '../../../models/users/user';
import { UserService } from '../../../models/users/userService';
import { TableView } from '../../ui/filterable-table/tableView';
import { UserTableViewComponent } from '../../user/user-table-view/user-table-view.component';
import { Merchant } from '../../../models/merchant/merchant';
import { FormMode } from '../../../core/constants';
import { EditUserComponent } from '../../user/edit-user/edit-user.component';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { SearchFilters } from '../../../models/search/searchFilters';

@Component({
  selector: 'app-merchant-users',
  templateUrl: './merchant-users.component.html',
  standalone: false,
})
export class MerchantUsersComponent {
  @Input() merchant: Merchant | undefined;
  @Input() enableEditing: boolean = false;
  //@Input() enableImpersonation: boolean = false;
  @Input() enableRoleSelection: boolean = true;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChild('userTable') userTableControl: UserTableViewComponent | undefined;
  @ViewChild('newUserForm') newUserForm: EditUserComponent | undefined;
  @ViewChild('editUserForm') editUserForm: EditUserComponent | undefined;

  //newUser:boolean = false;

  userTableView: any;
  userTableOptions: any = {
    selectAction: 'none',
    filterable: false,
    paginated: false,
    allowImpersonation: false,
  };

  selectedUser: Partial<User> | undefined;
  addingUser: boolean = false;
  editingUser: boolean = false;

  public get formMode(): typeof FormMode {
    return FormMode;
  }

  /////////

  constructor(
    public storage: StorageService,
    public userService: UserService,
    public uiErrorHandler: UIErrorHandler,
    public accessManager: AccessManager,
  ) {
    this.merchant = undefined;
  }

  ngOnChanges() {
    /*
    let enableEditingChange = changes['enableEditing'];
    let enableImpersonationChange = changes['enableImpersonation']

    if (enableEditingChange) {
      this.userTableOptions.allowEditing = enableEditingChange.currentValue;
      this.userTableControl?.setOptions(this.userTableOptions)
    }
    else if (enableImpersonationChange) {
      this.userTableOptions.allowImpersonation = enableImpersonationChange.currentValue;
      this.userTableControl?.setOptions(this.userTableOptions)
    }
    */
  }

  ngOnInit() {
    if (!this.merchant || this.merchant.id == '') {
      throw 'no merchant selected';
    }

    this.userTableView = new TableView(UserTableViewComponent);

    this.userTableOptions.merchantId = this.merchant.id;

    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_SELECT_ALL_USERS,
        AccessManager.AUTH_MANAGE_ALL_USERS,
        AccessManager.AUTH_IMPERSONATE_USER,
        AccessManager.AUTH_UPDATE_MERCHANT_USERS,
      ])
      .then((accessRecord) => {
        this.userTableOptions.allowEditing =
          accessRecord[AccessManager.AUTH_MANAGE_ALL_USERS];
        this.userTableOptions.allowEditing =
          this.userTableOptions.allowEditing ||
          accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_USERS];
        this.userTableOptions.allowImpersonation =
          accessRecord[AccessManager.AUTH_IMPERSONATE_USER];
        this.userTableControl?.setOptions(this.userTableOptions);
      });
  }

  /* hidden for now -- replaced by button
  handleRecordSelected(user:User) {
    this.editingUser = true;
    this.addingUser = false;
    this.selectedUser = user;
  }
*/
  /* MD Commented this out.  Moved access check for these permissions into this component's init() 
  public updatePermissions(canEdit:boolean, canImpersonate:boolean) {
    this.userTableOptions.allowEditing = canEdit;
    this.userTableOptions.allowImpersonation = canImpersonate;
    this.userTableControl?.setOptions(this.userTableOptions);
  }
*/
  handleUserSelected(id: string) {
    this.userService.getUserById(id).then((user) => {
      this.selectedUser = user;
      this.editingUser = true;
    });
  }

  handleUserSaved(data: any) {
    //user:Partial<User>
    this.editingUser = false;
    this.addingUser = false;
    this.userTableControl?.reload('', new SearchFilters({}), 1, 50);
    this.saved.emit(true);
  }

  handleUserCancelled() {
    this.selectedUser = undefined;
    this.editingUser = false;
    this.addingUser = false;
  }

  btnAddUser_click() {
    this.addingUser = true;
    this.editingUser = false;

    if (this.newUserForm) {
      this.newUserForm.enableEditing = this.enableEditing;
      this.newUserForm.enableSaving = true;
      this.newUserForm.enableSelectExistingUser = true;
      this.newUserForm.initialMode = this.formMode.Edit;
    }
  }

  btnCancel_click() {
    this.handleUserCancelled();
  }

  /*
  btnSave_click() {
    if (this.userForm) {
      let promise = this.userForm.saveNewUser();

      if (promise) {
        promise
        .then(response => {
          this.addingUser = false;
          this.editingUser = false;
        }).catch(message => {
          this.uiErrorHandler.handleError(message);
        })
      }

    }
  }
*/
}
